<div class="academic-section" [formGroup]="formGroup">

  <div [formArrayName]="controlName">

    <div *ngFor="let item of formArray.controls; let i = index" [formGroupName]="i"
      class="qualification-card row g-3 align-items-end">

      <!-- Date Range -->
      <!-- Enlistment Date -->
      <div class="col-md-6">
        <mat-label class="field-label">Start Date</mat-label>
        <mat-form-field class="w-100">

          <input matInput formControlName="startDate" [matDatepicker]="picker1"  placeholder="MM/YYYY" required>
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 startView="multi-year" (monthSelected)="setstartDateMonthAndYear($event, picker1,i)"
            panelClass="month-picker"></mat-datepicker>
          @let startDateControl = item.get('startDate');

          @if(startDateControl?.invalid && (startDateControl?.touched || startDateControl?.dirty)) {
          <mat-error>
            @if(startDateControl?.errors?.['required']) {
            <span>{{message}}</span>
            }@else {
            <span></span>
            }
          </mat-error>
          }

        </mat-form-field>
      </div>

      <!-- ORD Date -->
      <div class="col-md-6">
        <mat-label class="field-label">End Date</mat-label>
        <mat-form-field class="w-100">

          <input matInput formControlName="endDate" [matDatepicker]="picker2"  placeholder="MM/YYYY" required>
          <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 startView="multi-year" (monthSelected)="setendDateMonthAndYear($event, picker2,i)"
            panelClass="month-picker"></mat-datepicker>
          @let endDateControl = item.get('endDate');
          @if(endDateControl?.invalid && (endDateControl?.touched || endDateControl?.dirty)) {
          <mat-error>
            @if(endDateControl?.errors?.['required']) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>
      @if(item.errors?.['invalidDateRange']){
      <mat-error>
        <span> End date must be after start date.</span>
      </mat-error>
      }

      <!-- Qualification -->
      <div class="col-md-6">
        <label class="field-label">Academic Qualification (GCE ‘A’, Diploma, Degree)</label>
        <mat-form-field class="w-100">
          <input matInput formControlName="qualification" required>
          @let qualificationControl = item.get('qualification');
          @if(qualificationControl?.invalid && (qualificationControl?.touched || qualificationControl?.dirty)) {
          <mat-error>
            @if(qualificationControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Institution -->
      <div class="col-md-6">
        <label class="field-label">Name of Institution</label>
        <mat-form-field class="w-100">
          <input matInput formControlName="institution" required>
          @let institutionControl = item.get('institution');
          @if(institutionControl?.invalid && (institutionControl?.touched || institutionControl?.dirty)) {
          <mat-error>
            @if(institutionControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="row g-3">
        <!-- transcript Upload -->
        <div class="col-md-6">
          @if( i != 0){
          <mat-checkbox formControlName="transcriptfilecheck"
            (change)="onCheckboxChange($event.checked,'transcriptfilecheck','transcriptfileName',i)">Do not have a
            transcript</mat-checkbox>
          }
          <label class="field-label">Upload Document(Transcript)</label>

          <div class="upload-container">
            <div class="upload-box">
              <input type="file" id="transcriptfileName" [disabled]="readonly()" accept=".pdf,.jpg,.jpeg,.png"
                (change)="ontranscriptFileChange($event,i)">
              <input type="text" formControlName="transcriptfileName" hidden>
              @let documentControl = item.get('transcriptfileName');

              <!-- Show filename OR placeholder -->
              @if(!documentControl?.value){
              <span>
                Choose a file
              </span>
              }
              @if(documentControl?.value){
              <div class="attachment-row">
                <span class="file-name">
                  {{ documentControl?.value }}
                </span>
                @if(readonly() == false){
                <button mat-icon-button color="primary" class="delete-btn"
                  (click)="removeFile('transcriptfileName','transcriptfile','academic_transcript',i)">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <button mat-icon-button color="primary" class="delete-btn"
                (click)="previewtranscriptAttachment('transcriptfileName',i)">
                <mat-icon>visibility</mat-icon>
                </button>
              </div>
              }
            </div>
          </div>
          @if(documentControl?.invalid && (documentControl?.touched || documentControl?.dirty)){
          <mat-error>
            @if(documentControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }@else if(documentControl?.errors?.['invalidType']){
            <span>Only PDF, JPG, PNG files are allowed.</span>
            }
            @else if(documentControl?.errors?.['maxSize']){
            <span>File size must be less than or equal to 5MB.</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </div>
        <!-- certificate Upload -->
        <div class="col-md-6">
          @if( i != 0){
          <mat-checkbox formControlName="certificatefilecheck"
            (change)="onCheckboxChange($event.checked,'certificatefilecheck','certificatefileName',i)">Do not have a
            certificate
          </mat-checkbox>
          }
          <label class="field-label">Upload Document(certificate)</label>
          <div class="upload-container">
            <div class="upload-box">
              <input type="file" id="certificatefileName" [disabled]="readonly()" accept=".pdf,.jpg,.jpeg,.png"
                (change)="oncertifivateFileChange($event,i)">
              <input type="text" formControlName="certificatefileName" hidden>
              @let certificatedocumentControl = item.get('certificatefileName');

              <!-- Show filename OR placeholder -->
              @if(!certificatedocumentControl?.value){
              <span>
                Choose a file
              </span>
              }
              @if(certificatedocumentControl?.value){
              <div class="attachment-row">
                <span class="file-name">
                  {{certificatedocumentControl?.value }}
                </span>
                @if(readonly() == false){
                <button mat-icon-button color="primary" class="delete-btn"
                  (click)="removeFile('certificatefileName','certificatefile','Academic',i)">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <button mat-icon-button color="primary" class="delete-btn"
                (click)="previewAttachment('certificatefileName',i)">
                <mat-icon>visibility</mat-icon>
                </button>
              </div>
              }
            </div>
          </div>
          @if(certificatedocumentControl?.invalid && (certificatedocumentControl?.touched ||
          certificatedocumentControl?.dirty)){
          <mat-error>
            @if(certificatedocumentControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }@else if(certificatedocumentControl?.errors?.['invalidType']){
            <span>Only PDF, JPG, PNG files are allowed.</span>
            }
            @else if(certificatedocumentControl?.errors?.['maxSize']){
            <span>File size must be less than or equal to 5MB.</span>
            }
            @else {
            <span></span>
            }
          </mat-error>  
          }
        </div>
      </div>

      <!-- Delete -->
      <div class="col-md-3 text-end">
        @if (formArray.length > 1 && readonly() == false) {
        <button mat-stroked-button color="warn" type="button" (click)="removeRow(i)"><mat-icon>delete</mat-icon>Delete
          Qualification</button>
        }
      </div>

    </div>

  </div>
  @if(readonly() === false){
  <!-- Add Button -->
  <div class="text-end mt-3">
    <button mat-stroked-button color="primary" type="button" (click)="addRow()">
      + Add Academic
    </button>
  </div>
  }
</div>
@if(readonly() === false){
<!-- Form Actions -->
<div class="form-actions">

  <button class="save-btn" (click)="saveAndContinue()">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>

</div>
}